export enum FormMetricsAssessmentModel {
  Single = 'Single',
  Twice = 'Twice',
}

export enum FormMetricsSubmissionStatus {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  LATE = 'LATE',
  REALIZED = 'REALIZED',
  FINISHED = 'FINISHED',
}

export enum FormMetricsChartType {
  UNSET = 'UNSET',
  PIZZA = 'PIZZA',
  BAR = 'BAR',
  THERMOMETER = 'THERMOMETER',
  BINARY_THERMOMETER = 'BINARY_THERMOMETER',
  COMMENT = 'COMMENT',
  TEMPORAL_EVOLUTION = 'TEMPORAL_EVOLUTION',
}
